import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const CreateClientHeaderWrapper = styled.div`
  margin: 4px 0px 0px;

  .create-client-header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    flex-direction: row;
    gap: 16px;
  }

  .header-left {
    display: flex;
    .line {
      display: block;
      width: 2px;
      height: 48px;
      border: 3px solid ${COLORS.primary_light_blue3};
      border-radius: 4px;
    }
    .text {
      padding-left: 8px;
    }
  }
  .header-right {
    align-items: center;
    display: flex;
    justify-content: end;
  }
  .header-edit-client {
    margin-left: 12px;
    margin-right: 16px;
    ${responsive.MOBILE`
       margin-left: 0px;
       width: 100%;
       margin-bottom: 16px;
    `}
  }
  .header-view-hierarchy {
    height: auto;
    width: auto;
  }

  .hierarchyIcon {
    padding: 10px;
  }
`;
